import { APIGet } from '../services/API'


export const getEpisodes = (month, year, category, view, ics = null) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_EVENTS',
        payload: {
            ui: "loading"
        }
    });

    let url = site + '/api/v1/events';

    let qs = [];

    if (month) qs.push('month=' + month);
    if (year) qs.push('year=' + year);
    if (category) qs.push('category=' + category);
    if (view) qs.push('view=' + view)
    if (ics) qs.push('ics=' + ics);

    let queryString = qs.join('&');
    url += '?' + queryString;


    // Send Request To Get Events
    APIGet(url)
        .then(res => res.json())
        .then(json => {
            dispatch({ type: 'GET_EVENTS_SUCCESS', payload: { ui: "success", events: json } });
        })
        .catch(e => {
            dispatch({ type: 'GET_EVENTS_ERROR', payload: { ui: "error", message: e } });
        })

}

export const getPCOCalendarEvents = (month, year, category, view) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_EVENTS',
        payload: {
            ui: "loading"
        }
    });

    let url = site + '/api/v1/pco/v2/calendar';

    let qs = [];

    if (month) qs.push('month=' + month);
    if (year) qs.push('year=' + year);
    if (category) qs.push('category=' + category);
    if (view) qs.push('view=' + view)

    let queryString = qs.join('&');
    url += '?' + queryString;


    // Send Request To Get Events
    APIGet(url)
        .then(res => res.json())
        .then(json => {
            dispatch({ type: 'GET_EVENTS_SUCCESS', payload: { ui: "success", events: json } });
        })
        .catch(e => {
            dispatch({ type: 'GET_EVENTS_ERROR', payload: { ui: "error", message: e } });
        })

}



